import { styled, Typography } from '@mui/material';

export const HeaderW = styled('div')`
  margin-bottom: 16px;
  display: flex;
  align-items: flex-start;
  @media (max-width: 1023px) {
    margin-bottom: 16px;
    padding-top: 0px;
  }
`;

export const PageTitle = styled(Typography)`
  font-weight: 700;
  font-size: 32px;
  line-height: 40px;
  color: ${({ theme }) => theme.palette.primary.p080};
  white-space: break-spaces;
  @media (max-width: 1023px) {
    font-weight: 500;
    font-size: 32px;
    line-height: 40px;
  }
`;

export const PageSubTitle = styled(Typography)`
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  color: ${({ theme }) => theme.palette.primary.p080};
  white-space: break-spaces;
  @media (max-width: 1023px) {
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
  }
`;

export const TitleW = styled(Typography)`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const SubTitleAccesnt = styled(Typography)`
  display: inline;
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  color: ${({ theme }) => theme.palette.primary.grey};
  white-space: break-spaces;
  @media (max-width: 1023px) {
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
  }
`;

export const TitleAccent = styled('span')`
  color: ${({ theme }) => theme.palette.info.main};
`;

export const CloseButtonW = styled('div')`
  margin-left: auto;
  position: fixed;
  top: 79px;
  right: 88px;
  cursor: pointer;
  @media (max-width: 1023px) {
    position: static;
    svg {
      width: 24px;
      height: 24px;
    }
  }
`;

export const PageHeaderW = styled('div')`
  width: 100%;
  max-width: 671px;
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 1023px) {
    margin-bottom: 16px;
    max-width: unset;
  }
`;
